import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';

import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getAccountLandLordType,
  getCompanyData,
  getBusinessVatRegistration,
} from '../../features/registration/registrationJourneySlice';
import { completeRegistration } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const PasswordCreated = () => {
  const landlordTypeSelectedRedux = useSelector(getAccountLandLordType);
  const companyDataSelectedRedux = useSelector(getCompanyData);
  const vatRegistrationSelectedRedux = useSelector(getBusinessVatRegistration);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'landlordReg.Declaration.s14',
    'Declaration - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const history = useHistory();

  const isValidComapanyData = () => {
    let isValidBln = true;
    if (companyDataSelectedRedux === '') {
      isValidBln = false;
    } else if (companyDataSelectedRedux === null) {
      isValidBln = false;
    } else if (companyDataSelectedRedux === undefined) {
      isValidBln = false;
    }
    return isValidBln;
  };

  const isValidVatData = () => {
    let isValidBln = true;
    if (vatRegistrationSelectedRedux === '') {
      isValidBln = false;
    } else if (vatRegistrationSelectedRedux === null) {
      isValidBln = false;
    } else if (vatRegistrationSelectedRedux === undefined) {
      isValidBln = false;
    }
    return isValidBln;
  };

  const isPrp = () => {
    let isPrpBln = false;
    if (process.env.REACT_APP_FLAG_PRP.toLowerCase() === 'true') {
      if (
        landlordTypeSelectedRedux ===
        'Property factor or a social housing provider'
      ) {
        if (isValidComapanyData() || isValidVatData()) {
          isPrpBln = false;
        } else {
          isPrpBln = true;
        }
      } else {
        isPrpBln = false;
      }
    } else {
      isPrpBln = false;
    }
    return isPrpBln;
  };

  const handleBtnClick = () => {
    completeRegistration()
      .then(() => {
        if (isPrp()) {
          history.push('/landlordReg/prp-account-submitted');
        } else {
          history.push('/landlordReg/account-created');
        }
      })
      .catch(() => {
        // TODO: Show error message
      });
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('landlordReg.Declaration.s1', 'Declaration')}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.Declaration.s2',
          'By continuing, you confirm that you:'
        )}
      </p>

      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'landlordReg.Declaration.s3',
            'have checked and will comply with the '
          )}
          <a
            href="https://www.gov.uk/government/publications/ev-chargepoint-grant-for-landlords-customer-guidance"
            target="_blank"
            className="govuk-link"
            rel="noreferrer"
          >
            {copyProvider.getCopy(
              'landlordReg.Declaration.s11',
              'grant rules and requirements '
            )}
            <span className="govuk-visually-hidden">
              {copyProvider.getCopy(
                'landlordReg.Declaration.s13',
                '(opens in new tab)'
              )}
            </span>
          </a>
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordReg.Declaration.s4',
            'will use the grant to only install electric vehicle chargepoints on properties with private parking'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordReg.Declaration.s5',
            'understand the information provided and any supporting evidence will be used to assess your claim for the grant'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordReg.Declaration.s6',
            'understand that the information and supporting evidence will be used to assess your application and claim for this grant'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordReg.Declaration.s7',
            'agree to work with OZEV or its agents should this installation be approved for audit'
          )}
        </li>
      </ul>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.Declaration.s8',
          'You also confirm that when installing a chargepoint, you will consider the accessibility and mobility needs of EV owners.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.Declaration.s9',
          'Your information will be handled in accordance with the '
        )}
        <a
          href="https://www.gov.uk/government/organisations/office-for-low-emission-vehicles/about/personal-information-charter"
          target="_blank"
          className="govuk-link"
          rel="noreferrer"
        >
          {copyProvider.getCopy(
            'landlordReg.Declaration.s12',
            'OZEV personal information charter '
          )}
          <span className="govuk-visually-hidden">
            {copyProvider.getCopy(
              'landlordReg.Declaration.s13',
              '(opens in new tab)'
            )}
          </span>
        </a>
      </p>
      <Button
        className="govuk-button govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordReg.Declaration.s10',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
};

export default PasswordCreated;
